
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Kothrudtomumbaicab() {



    const cardData =
    {
        keyword: '  Kothrud to Mumbai Cab',
        heading: 'Skyline Cabs:  Kothrud to Mumbai Cab',
        headingDescription: 'Skyline Cabs provides safe and convenient Kothrud to Mumbai Cab services. Whether you are traveling for business, a weekend getaway, or an airport transfer, our professional drivers and well-maintained vehicles ensure a smooth and comfortable ride. With affordable fares, on-time service, and a focus on customer satisfaction, Skyline Cabs makes your journey from Kothrud to Mumbai seamless and stress-free. Book your cab today for a reliable travel experience.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Kothrud to Mumbai Airport Cab",
      "description": "Skyline Cabs provides safe and comfortable cab services from Kothrud to Mumbai Airport. Enjoy a hassle-free airport transfer with professional drivers and well-maintained vehicles like Ertiga and Innova."
    },
    {
      "name": "Kothrud to Mumbai International Airport Cab",
      "description": "Book a cab with Skyline Cabs for your journey from Kothrud to Mumbai International Airport. We offer timely pickups, spacious vehicles, and courteous service to ensure a smooth ride."
    },
    {
      "name": "Kothrud to Mumbai One Way Cab",
      "description": "Skyline Cabs offers reliable one-way cab services from Kothrud to Mumbai. Ideal for solo or family travelers, our fleet includes sedans, Ertiga, and Innova for your comfort."
    },
    {
      "name": "Kothrud to Mumbai Drop Taxi",
      "description": "Need a drop to Mumbai from Kothrud? Skyline Cabs provides convenient and affordable drop taxi service with experienced drivers and a variety of vehicle options."
    },
    {
      "name": "Kothrud to Dadar Taxi Service",
      "description": "Skyline Cabs offers prompt and comfortable taxi services from Kothrud to Dadar. Choose from Ertiga, Innova, or sedans for a smooth city transfer."
    },
    {
      "name": "Kothrud to Bandra Taxi Service",
      "description": "Travel from Kothrud to Bandra comfortably with Skyline Cabs. Our trained drivers and clean vehicles ensure a safe and enjoyable ride to your Mumbai destination."
    },
    {
      "name": "Kothrud to Mumbai Darshan Cab",
      "description": "Explore Mumbai with Skyline Cabs' Darshan cab service from Kothrud. Perfect for sightseeing and full-day city tours, with flexible booking options and experienced chauffeurs."
    },
    {
      "name": "Pune to Mumbai Taxi",
      "description": "Skyline Cabs offers premium taxi services from Pune to Mumbai. Our service includes one-way, round trip, and airport transfers with a range of vehicle choices."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "For reliable airport transfers, choose Skyline Cabs for your journey from Pune to Mumbai Airport. Timely service and comfort are our priorities."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Book an Ertiga with Skyline Cabs for a spacious and economical ride from Pune to Mumbai. Perfect for small families and group travel."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Travel in luxury with Skyline Cabs' Innova cab from Pune to Mumbai. Ideal for business or family trips, offering superior comfort and space."
    },
    {
      "name": "Kothrud to Mumbai Cab Service",
      "description": "Skyline Cabs provides dependable cab services from Kothrud to Mumbai, including airport drops and intercity rides, with options for one-way or round trips."
    },
    {
      "name": "Kothrud to Mumbai Innova Cab Service",
      "description": "Need more space and comfort? Choose our Innova cab service from Kothrud to Mumbai, perfect for long-distance rides with family or colleagues."
    },
    {
      "name": "Kothrud to Dadar Cab Service",
      "description": "Skyline Cabs offers direct cab service from Kothrud to Dadar. Our experienced drivers and clean vehicles guarantee a smooth and punctual ride."
    },
    {
      "name": "Kothrud to Andheri Cab Service",
      "description": "Travel to Andheri from Kothrud with ease using Skyline Cabs. We provide timely, comfortable rides with multiple vehicle options including Innova and Ertiga."
    },
    {
      "name": "Innova Crysta on Rent in Kothrud Pune",
      "description": "Skyline Cabs offers Innova Crysta on rent in Kothrud, perfect for business travel, family outings, or outstation trips with added luxury and space."
    },
    {
      "name": "Toyota Innova Crysta Car Hire in Pune",
      "description": "Hire a Toyota Innova Crysta from Skyline Cabs in Pune for smooth and luxurious travel. Available for local and intercity trips with flexible rental plans."
    },
    {
      "name": "Pune Mumbai Skyline Cabs",
      "description": "Skyline Cabs is your trusted travel partner between Pune and Mumbai. We offer safe, reliable, and budget-friendly intercity cab services with a variety of vehicle options."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs delivers professional cab services in Pune. Whether you're traveling locally or heading to Mumbai, we ensure a smooth and comfortable journey."
    },
    {
      "name": "Cab Service in Kothrud",
      "description": "Skyline Cabs offers dedicated cab service in Kothrud. From local travel to long-distance trips, we provide clean vehicles and courteous drivers for every ride."
    },
    {
      "name": "Cab Service in Kothrud Contact Number",
      "description": "Need a cab in Kothrud? Contact Skyline Cabs for quick bookings and support. Our helpline is available 24/7 to assist you with your travel needs."
    },
    {
      "name": "Kothrud to Outstation Cabs Service",
      "description": "Planning a trip outside Pune? Skyline Cabs offers outstation cab services from Kothrud with competitive pricing and vehicle options like Innova, Ertiga, and sedans."
    }
  ],
  "tableData": [
    ["Kothrud to Mumbai Airport Cab", "Kothrud to Mumbai International Airport Cab"],
    ["Kothrud to Mumbai One Way Cab", "Kothrud to Mumbai Drop Taxi"],
    ["Kothrud to Dadar Taxi Service", "Kothrud to Bandra Taxi Service"],
    ["Kothrud to Mumbai Darshan Cab", "Pune to Mumbai Taxi"],
    ["Pune to Mumbai Airport Cab", "Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "Kothrud to Mumbai Cab Service"],
    ["Kothrud to Mumbai Innova Cab Service", "Kothrud to Dadar Cab Service"],
    ["Kothrud to Andheri Cab Service", "Innova Crysta on Rent in Kothrud Pune"],
    ["Toyota Innova Crysta Car Hire in Pune", "Pune Mumbai Skyline Cabs"],
    ["Cab Service in Pune", "Cab Service in Kothrud"],
    ["Cab Service in Kothrud Contact Number", "Kothrud to Outstation Cabs Service"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Kothrud to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers punctual and dependable cab services from Kothrud to Mumbai, ensuring you arrive on time, every time. Whether you're traveling for work, leisure, or catching a flight, we prioritize your comfort and convenience throughout the journey."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our fleet of well-maintained vehicles, including sedans, SUVs, and luxury cars, ensures a comfortable ride from Kothrud to Mumbai. Each vehicle is equipped with air-conditioning, ample legroom, and a smooth ride, so you can enjoy a stress-free journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Skyline Cabs drivers are skilled, experienced, and knowledgeable about the best routes from Kothrud to Mumbai. They are courteous, background-checked, and committed to providing a safe and comfortable ride throughout your journey."
    },
    {
        "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
        "WhyChoosedescription": "We offer competitive and transparent pricing for your Kothrud to Mumbai journey. With no hidden charges or surprises, you can plan your travel budget with confidence, knowing the exact cost up front."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs is available around the clock, ensuring that you can book a cab from Kothrud to Mumbai at any time. Whether it’s a late-night ride or an early morning journey, we’re always ready to serve you."
    },
    {
        "WhyChooseheading": "Variety of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "Whether you’re traveling alone, with family, or with a group, we have the right vehicle for you. From budget-friendly hatchbacks to spacious SUVs and luxury cars, we offer a wide selection of vehicles for a comfortable journey from Kothrud to Mumbai."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
        "WhyChoosedescription": "Booking your cab from Kothrud to Mumbai is simple and quick with our easy-to-use website and mobile app. Get instant booking confirmations, view fare estimates, and track your cab in real-time for a seamless experience."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel Experience",
        "WhyChoosedescription": "We prioritize your safety above all else. All Skyline Cabs are GPS-enabled for real-time tracking, and our drivers undergo thorough background checks. Travel confidently knowing you’re in safe hands during your Kothrud to Mumbai trip."
    }
]












    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Kothrud to Mumbai cab with Skyline Cabs?',
            answer:
                'You can book easily through our website, mobile app, or by calling our customer care team. Select Kothrud as your pickup point and Mumbai as the destination, choose a car type, and confirm your ride within minutes.',
        },
        {
            id: 2,
            question: 'What cab options are available for Kothrud to Mumbai travel?',
            answer:
                'We offer hatchbacks, sedans, SUVs, and premium vehicles. Whether you’re traveling solo or with a group, Skyline Cabs has the right option to match your comfort and budget.',
        },
        {
            id: 3,
            question: 'Is the fare fixed or will it change based on distance?',
            answer:
                'Skyline Cabs offers fixed pricing for the Kothrud to Mumbai route. All tolls, taxes, and any extra charges are included and clearly shown at the time of booking — no surprises later!',
        },
        {
            id: 4,
            question: 'Can I book a round trip from Kothrud to Mumbai?',
            answer:
                'Yes, you can choose between one-way and round-trip bookings. Just enter your return date and time when booking, and we’ll take care of the rest.',
        },
        {
            id: 5,
            question: 'How long does the journey take from Kothrud to Mumbai?',
            answer:
                'The journey generally takes around 3 to 3.5 hours, depending on traffic. Our experienced drivers choose the best routes for a smooth and timely ride.',
        },
        {
            id: 6,
            question: 'Are your drivers trained for long-distance travel?',
            answer:
                'Absolutely. All our drivers are experienced, background-verified, and well-trained in long-distance travel. Your safety and comfort are our top priorities.',
        },
        {
            id: 7,
            question: 'Can I pre-book a cab for this route?',
            answer:
                'Yes, pre-booking is available and recommended for busy weekends or peak hours. Use our app or website to schedule your ride in advance.',
        },
        {
            id: 8,
            question: 'Do you offer airport drop-off from Kothrud to Mumbai?',
            answer:
                'Yes, we provide direct drop-offs to both Mumbai Domestic and International Airports from Kothrud. Share your flight details with us to ensure on-time arrival.',
        },
        {
            id: 9,
            question: 'What if I need to cancel or modify my booking?',
            answer:
                'You can easily cancel or modify your ride through our app or website. Our customer support team is also available 24/7 to assist you with any changes.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Kothrud to Mumbai journey?',
            answer:
                'Skyline Cabs offers a premium, safe, and affordable cab experience. With professional drivers, clean and comfortable vehicles, and transparent pricing, we make your intercity travel completely hassle-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Suresh Naik",
            rating: 5,
            review: "Booked a cab from Kothrud to Mumbai for a family trip. The driver arrived right on time, the car was clean and spacious, and we reached comfortably. Skyline Cabs is now my go-to service for outstation travel!"
        },
        {
            name: "Miss. Meenal Joshi",
            rating: 4,
            review: "I was impressed with the service quality. Smooth ride, polite driver, and very professional. Would have given 5 stars if there was in-car Wi-Fi, but everything else was perfect!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kothrud to Mumbai Cab Service",
  "image": "https://skylinecabs.com/assets/images/kothrud-to-mumbai-cab.jpg",
  "description": "Book Kothrud to Mumbai cab service with Skyline Cabs for a smooth, affordable, and timely ride. Choose AC sedans, SUVs, or premium cars with professional drivers — available 24/7 for one-way and round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7682"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/kothrud-to-mumbai-cab-service"
  }
};



      
      
      

    return (
        <div>
<Helmet>
  <title>Kothrud to Mumbai Cab Service | Safe & Affordable Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Kothrud to Mumbai cab service with Skyline Cabs for a smooth, affordable, and timely ride. Choose AC sedans, SUVs, or premium cars with professional drivers — available 24/7 for one-way and round trips." 
  />
  <meta 
    name="keywords" 
    content="Kothrud to Mumbai Cab Service, Cab from Kothrud to Mumbai, One-Way Taxi Kothrud to Mumbai, Round Trip Cab Kothrud to Mumbai, AC Cab Kothrud to Mumbai, SUV Taxi Kothrud to Mumbai, 24/7 Cab Booking Kothrud to Mumbai, Online Cab Kothrud to Mumbai, Skyline Cabs Kothrud to Mumbai, Affordable Cab Kothrud to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/16.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kothrudtomumbaicab;